<template>
    <div class="header" :class="{'banner_bg': banner_bg}">
        <div class="header-area">
            <div class="left">
                <img :src="$store.state.static_img_url+'pic/logo_whrite.png?v='+ $store.state.version" @click="returnIndex">
                <div class="content">
                    <div @click="routerTo('Index', '#one')" :class="{'active': isposition?isposition == '#one':is_active == '' || is_active == '#one'}">首页<div class="line"></div></div>
                    <div @click="routerTo('Index', '#two')" :class="{'active': isposition?isposition == '#two': is_active == '#two' }">产品与服务<div class="line"></div></div>
                    <div @click="routerTo('Index', '#three')" :class="{'active': isposition?isposition == '#three':is_active == '#three'}">产品特色<div class="line"></div></div>
                    <div @click="routerTo('About')" :class="{'active': is_active == 'About'}">关于我们<div class="line"></div></div>
                    <div @click="routerTo('Log')" :class="{'active': is_active == 'Log'}">更新日志<div class="line"></div></div>
                    <div @click="routerTo('HelpCenter')" :class="{'active': is_active == 'HelpCenter'}">帮助中心<div class="line"></div></div>
                    <div><a href="https://vbdata.cn/buyVip" target="_blank">会员服务</a> <div class="line"></div></div>
                </div>
            </div>
            <div class="right">
                <div class="one button" @click="haddleApplyTry2(12)">机构版试用申请</div>
                <div class="two-group header-user">
                    <span class="two button"
                        v-if="user_key == ''"
                        @click="showLogin"
                    >登录</span>
                    <Dropdown v-else class="cancel" @on-click="clickDropDown" trigger="click" placement="bottom-end">
                        <img :src="wx_image" v-if="wx_image" />
                        <i class="iconfont default_header" v-else>&#xe65b;</i>
                        <DropdownMenu slot="list">
                            <DropdownItem name="collect"><i class="iconfont-sm">&#xe66e;</i><span>我的收藏</span></DropdownItem>
                            <DropdownItem name="coupon"><i class="iconfont-sm">&#xe67e;</i><span>优惠券</span></DropdownItem>
                            <DropdownItem name="order"><i class="iconfont-sm">&#xe614;</i><span>订单管理</span></DropdownItem>
                            <DropdownItem name="my_product"><i class="iconfont-sm">&#xe623;</i><span>已购产品</span></DropdownItem>
                            <DropdownItem name="account"><i class="iconfont-sm">&#xe61e;</i><span>账号设置</span></DropdownItem>
                            <DropdownItem name="quit"><i class="iconfont-sm">&#xe620;</i><span>退出</span></DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </div>
            </div>
        </div>
        <login :loginModal="loginModal" @logincancel="loginCancel"></login>
    </div>
</template>

<script>
import Login from '@/components/Login.vue'
import AddApply from '@/components/AddApply.vue'
import { loginOut, addTryEnterPV } from '../service'
import Cookies from 'js-cookie'
export default {
    props: ['needscroll', 'isposition'],
    data() {
        return {
            banner_bg: false,
            loginModal: false,
            apply_modal: false,
        }
    },
    components: {
        Login
    },
    computed: {
        user_key() {
            return this.$store.state.user_key
        },
        user() {
            return this.$store.state.user
        },
        wx_image() {
            let user_info
            if(this.user && typeof this.user == 'string'){
                user_info = JSON.parse(this.user)
                return user_info.wx_avatarurl
            }else if(this.user && typeof this.user == 'object'){
                return this.user.wx_avatarurl
            }else{
                return false
            }
        },
        is_active() {
            if(this.$route.name != 'Index') {
                return this.$route.name
            } else {
                return this.$route.hash
            }
        }
    },
    methods: {
        async addTryEnterPV(info_src) {
            let res = await addTryEnterPV({ 
                info_src: info_src,
                userid: this.$store.state.user.id
            }, (error) => {
                this.$Message.error('请求错误！')
            })
        },
        haddleApplyTry2(info_src) {
            // this.addTryEnterPV(info_src)
            let link = this.$store.state.index_path + '/applyTry?info_src=' + info_src
            window.open(link)
        },
        showLogin() {
            this.loginModal = !this.loginModal
        },
        loginCancel(value) {
            this.loginModal = value
            if(!value) {
                this.clearModal2BodyStyle()
            }
        },
        applyModelClose(bl) {
            this.apply_modal = bl
            if(!bl) {
                this.clearModal2BodyStyle()
            }
        },
        clearModal2BodyStyle() {
            document.body.style.paddingRight = ''
            document.body.style.overflow = ''
        },
        async clickDropDown(name) {
            if (name == 'quit') { // 退出
                let res = await loginOut({user_key: this.user_key}, (error) => {
                this.$Message.error('请求错误！')
                })
                if(res.status == 'success') {
                    this.$Message.success('退出成功！')
                    this.$store.commit('updateUser', '')
                    this.$store.commit('updateUserKey', '')
                    this.$store.commit('updateFilter', '')
                    this.$store.commit('topicEntityCount', '')
                    this.$store.commit('topicTagCount', '')
                    this.$store.commit('updateIdentity', true)
                    this.$store.commit('setUUserId', null)
                    Cookies.remove('user_key_'+this.$store.state.cookie_type, { domain: this.$store.state.domain_path, path: '/' })

                    window.localStorage.removeItem('show_scientific')
                    this.$store.commit('updateTiaojian', '')

                    const frame = document.getElementById('loginTarget');
                    frame.contentWindow.postMessage({ 
                        loginStatus: 'quit'
                    },'*'); 
                    this.$router.push({ query: {} })
                } else {
                this.$Message.error(res.message)
                }
            }
            if (name == 'coupon') { // 优惠券
                this.$router.push({name: 'UserCoupon'})
            }
            if (name == 'order') { // 我的订单
                this.$router.push({name: 'OrderList'})
            }
            if (name == 'my_product') { // 我的报告
                this.$router.push({name: 'UserProduct'})
            }
            if (name == 'account') { // 账号设置
                this.$router.push({name: 'UserAccount'})
            }
            if (name == 'collect') { // 个人主页
                this.$router.push({name: 'UserCollect'})
            }
        },
        returnIndex() {
            if(this.$route.name != 'Index' ) {
                this.$router.push({name: 'Index'})
                // process.env.NODE_ENV == 'development'? window.open('http://192.168.1.104:8081') : window.open(this.$store.state.req_url)
            }
        },
        routerTo(name, hash) {
            if(hash) {
                this.$router.replace({ name: name, hash: hash})
                if(this.needscroll) {
                   this.$emit('dealhash', true, '') 
                }
            } else {
                this.$router.replace({ name: name})
            }
        },
        //监听滚动条
        handleScroll() {
            let top =
                pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
            if(this.needscroll) {
                this.$emit('scroll')
            }
            if (top > 10) {
                this.banner_bg = true;
            } else {
                this.banner_bg = false;
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.handleScroll()
            addEventListener("scroll", this.handleScroll)
        })
    },
    beforeDestroy() {
        removeEventListener("scroll", this.handleScroll)
    }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
.header
    position: fixed
    top: 0
    left: 0
    width: 100%
    z-index: 1000
    height: 64px
    &.banner_bg
        background: #11141c
    .header-area
        width: 1200px
        margin: 0 auto
        height: 100%
        display: flex
        align-items: center
        justify-content: space-between
        .left
            display: inline-flex
            align-items: center
            img
                height: 32px
                margin-right: 90px
            .content
                display: inline-flex
                align-items: center
                color: #F4F4F4
                font-size: 16px
                line-height:22px
                >div
                    position: relative
                    cursor: pointer
                    a
                        color: #fff
                    &:hover
                        color: #FA7A50
                        a
                            color: #FA7A50
                    &.active
                        font-weight: bold
                        color: #fff
                        .line
                            display: block
                    .line
                        position: absolute
                        bottom: -16px
                        width: 30px
                        height: 4px
                        background: #FA7A50
                        border-radius: 2px
                        left: 50%
                        transform: translateX(-50%)
                        display: none
                >div+div
                    margin-left: 30px
        .right
            display: inline-flex
            align-items: center
            .button
                padding: 5px 15px
                border: 1px solid
                font-size: 14px
                cursor: pointer
                &:hover
                    background: #FA7A50
                    color: #fff
                    border-color:  #FA7A50
            .one
                color: #FA7A50
                border-color:  #FA7A50
                margin-right: 20px
            .two
                color: #fff
                border-color:  #fff
.header-user
    flex: 0
    text-align: right
    > span
        display: inline-block
        color: #fff
        border:1px solid #fff
        font-size: 14px
        cursor: pointer
        text-align: center
        width: max-content
    // &:hover
    //     background:rgba(250, 122, 80, 1)
    //     border:1px solid rgba(250, 122, 80, 1)
    //     color #fff
    .default_header
        color: #fff
        vertical-align: top
        font-size: 30px
        margin-right: 0
        cursor: pointer
    img
        width: 30px
        height: 30px
        border-radius: 50%
        cursor: pointer
.cancel
    & >>> .ivu-select-dropdown
        border-radius: 0
        padding: 0
        background-color: #ffffff
        box-shadow: 0px -4px 20px 0px rgba(121,133,143,.1)
        width: 200px
        text-align: left
        .ivu-dropdown-item
            line-height: 1
            padding: 12px 16px
            vertical-align: middle
            &.ivu-dropdown-item-disabled:hover
                cursor: default
            i
                font-size: 18px
                margin-right: 12px
                color: #999
                vertical-align: middle
            span
                display: inline-block
                font-size: 14px
                cursor: pointer
                width: 70px
                vertical-align: middle
                line-height: 1
                text-align: left
                color: #666666
                background: none
            &:hover
                background-color: #F4F4F4
                span
                    color: #333333
                .iconfont-sm
                    color: rgba(250, 122, 80, 1)
            .ivu-switch
                float: right
                width: 28px
                margin-top: 1px
                &-checked
                    background: rgba(250, 122, 80, 1)
</style>